export const welcomeContent = {
    TH: {
        paragraph: [
            {
                line: [
                    'ระบบตรวจสอบพื้นที่ครอบคลุมสัญญาณทีวีดิจิทัล (DTV Service Area) นี้ จะแสดงช่องความถี่วิทยุใหม่ (“ช่องความถี่หลังปรับปรุง 700 MHz”) ใช้งานภายหลังจากการปรับปรุงโครงข่ายโทรทัศน์ภาคพื้นดินในระบบดิจิทัลเพื่อรองรับการเรียกคืนคลื่นความถี่ 700 MHz ซึ่งคาดว่าจะดำเนินการแล้วเสร็จในช่วงเดือนธันวาคม พ.ศ.2563 โดยกำหนดการปรับปรุงโครงข่ายอาจมีการปรับเปลี่ยนตามความเหมาะสม หรือตามอุปสรรคการดำเนินการ รวมถึงสถานการณ์การแพร่ระบาดของไวรัสโคโรน่า 2019 (สามารถดูข้อมูลเพิ่มเติมเกี่ยวกับแผนการปรับปรุงโครงข่ายโทรทัศน์ภาคพื้นดินในระบบดิจิทัล เพื่อรองรับการเรียกคืนคลื่นความถี่ 700 MHz ได้จาก https://700.nbtc.go.th)',
                ],
            },
            {
                line: [
                    'ข้อตกลงและเงื่อนไขบริการ',
                    'สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์และกิจการโทรคมนาคม (“สำนักงาน กสทช.”) เป็นเจ้าของและผู้ดูแลจัดการแอพพลิเคชันนี้ จุดประสงค์เพื่อช่วยเหลือประชาชนในการหาทิศทางในการรับสัญญาณโทรทัศน์ดิจิทัล โดยอาศัยแบบจำลองการแพร่กระจายคลื่นประกอบกับข้อมูลทางเทคนิคของผู้ให้บริการโครงข่ายเฉพาะในส่วนของสถานีหลัก และอาศัยข้อมูลภูมิประเทศในการคำนวณ ทั้งนี้ ข้อมูลทั้งหมดเป็นการวิเคราะห์จากซอฟแวร์ซึ่งเป็นการคาดการณ์ ขอสงวนความรับผิดที่อาจเกิดขึ้น ไม่ว่าทางตรงหรือทางอ้อม อันเกิดมาจากการนำข้อมูลนี้ไปใช้ทุกกรณี สำนักงาน กสทช. จะไม่รับผิดสำหรับความเสียหายใด ๆ',
                ],
            },
            {
                line: [
                    'ลิขสิทธิ์',
                    'สำนักงาน กสทช. เป็นเจ้าของลิขสิทธิ์ข้อมูลและส่วนประกอบอื่นๆ แอปพลิเคชันนี้ เว้นแต่จะระบุไว้เป็นอย่างอื่น ห้ามทำการดัดแปลง',
                ],
            },
            {
                line: [
                    'การใช้ข้อมูลและส่วนประกอบต่าง',
                    'ข้อมูลและส่วนประกอบต่างๆ ที่ปรากฏอยู่ในแอปพลิเคชันนี้ อาจมีการเปลี่ยนแปลงได้ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
                ],
            },
            {
                line: [
                    'ข้อจำกัด',
                    'พื้นที่ครอบคลุมสัญญาณทำขึ้นโดยอาศัยแบบจำลองการแพร่กระจายคลื่นประกอบกับข้อมูลทางเทคนิคของผู้ให้บริการโครงข่ายเฉพาะในส่วนของสถานีหลัก 39 สถานี และสถานีเสริมในกลุ่ม A1 45 สถานี ตามแผนการขยายโครงข่ายในปีที่ 1-3 รวมทั้งอาศัยข้อมูลภูมิประเทศในการคำนวณด้วย ซึ่งภายหลังการติดตั้งครบถ้วน คาดการณ์ว่าจะมีพื้นที่ครอบคลุมทั้งคิดสิ้นคิดเป็นร้อยละ 90 ของจำนวนครัวเรือนทั้งประเทศ',
                    'ทั้งนี้ การจัดหาอุปกรณ์หรือติดตั้งโครงข่ายในสภาพพื้นที่จริงอาจมีความแตกต่างจากแบบจำลองบ้าง โดยการวิเคราะห์นี้ได้คำนวณจากพื้นที่ครอบคลุมสัญญาณในลักษณะ Fixed Rooftop ดังนั้นการรับสัญญาณในลักษณะ Portable Indoor จะมีความแตกต่างบ้างขึ้นกับปัจจัยของสิ่งแวดล้อมอาทิตึกสูงอาคารบ้านหรือสิ่งกีดขวางต่างๆ',
                    'การขยายโครงข่ายระยะที่ 4 (ปีที่ 4) มีเป้าหมายครอบคลุมจำนวนครัวเรือนไม่น้อยกว่า ร้อยละ 95 โดยอาศัยการติดตั้งสถานีเสริมเป็นการเพิ่มเติม และสำนักงาน กสทช. จะปรับปรุงข้อมูลบนแอปพลิเคชั่นนี้ต่อไป',
                    'กำหนดการขยายโครงข่ายอาจมีการปรับเปลี่ยนตามความเหมาะสม หรือตามสถานการณ์/อุปสรรคการดำเนินการ',
                ],
            },
            {
                line: [
                    'กฎหมายที่ใช้บังคับ',
                    'การใช้แอปพลิเคชั่นนี้หรือการตีความข้อตกลงและเงื่อนไขการใช้บริการเว็บไซต์นี้ให้เป็นไปตามกฎหมายไทย',
                ],
            },
        ],
    },
    EN: {
        paragraph: [
            {
                line: [
                    'ระบบตรวจสอบพื้นที่ครอบคลุมสัญญาณทีวีดิจิทัล (DTV Service Area) นี้ จะแสดงช่องความถี่วิทยุใหม่ (“ช่องความถี่หลังปรับปรุง 700 MHz”) ใช้งานภายหลังจากการปรับปรุงโครงข่ายโทรทัศน์ภาคพื้นดินในระบบดิจิทัลเพื่อรองรับการเรียกคืนคลื่นความถี่ 700 MHz ซึ่งคาดว่าจะดำเนินการแล้วเสร็จในช่วงเดือนธันวาคม พ.ศ.2563 โดยกำหนดการปรับปรุงโครงข่ายอาจมีการปรับเปลี่ยนตามความเหมาะสม หรือตามอุปสรรคการดำเนินการ รวมถึงสถานการณ์การแพร่ระบาดของไวรัสโคโรน่า 2019 (สามารถดูข้อมูลเพิ่มเติมเกี่ยวกับแผนการปรับปรุงโครงข่ายโทรทัศน์ภาคพื้นดินในระบบดิจิทัล เพื่อรองรับการเรียกคืนคลื่นความถี่ 700 MHz ได้จาก https://700.nbtc.go.th)',
                ],
            },
            {
                line: [
                    'ข้อตกลงและเงื่อนไขบริการ',
                    'สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์และกิจการโทรคมนาคม (“สำนักงาน กสทช.”) เป็นเจ้าของและผู้ดูแลจัดการแอพพลิเคชันนี้ จุดประสงค์เพื่อช่วยเหลือประชาชนในการหาทิศทางในการรับสัญญาณโทรทัศน์ดิจิทัล โดยอาศัยแบบจำลองการแพร่กระจายคลื่นประกอบกับข้อมูลทางเทคนิคของผู้ให้บริการโครงข่ายเฉพาะในส่วนของสถานีหลัก และอาศัยข้อมูลภูมิประเทศในการคำนวณ ทั้งนี้ ข้อมูลทั้งหมดเป็นการวิเคราะห์จากซอฟแวร์ซึ่งเป็นการคาดการณ์ ขอสงวนความรับผิดที่อาจเกิดขึ้น ไม่ว่าทางตรงหรือทางอ้อม อันเกิดมาจากการนำข้อมูลนี้ไปใช้ทุกกรณี สำนักงาน กสทช. จะไม่รับผิดสำหรับความเสียหายใด ๆ',
                ],
            },
            {
                line: [
                    'ลิขสิทธิ์',
                    'สำนักงาน กสทช. เป็นเจ้าของลิขสิทธิ์ข้อมูลและส่วนประกอบอื่นๆ แอปพลิเคชันนี้ เว้นแต่จะระบุไว้เป็นอย่างอื่น ห้ามทำการดัดแปลง',
                ],
            },
            {
                line: [
                    'การใช้ข้อมูลและส่วนประกอบต่าง',
                    'ข้อมูลและส่วนประกอบต่างๆ ที่ปรากฏอยู่ในแอปพลิเคชันนี้ อาจมีการเปลี่ยนแปลงได้ โดยไม่ต้องแจ้งให้ทราบล่วงหน้า',
                ],
            },
            {
                line: [
                    'ข้อจำกัด',
                    'พื้นที่ครอบคลุมสัญญาณทำขึ้นโดยอาศัยแบบจำลองการแพร่กระจายคลื่นประกอบกับข้อมูลทางเทคนิคของผู้ให้บริการโครงข่ายเฉพาะในส่วนของสถานีหลัก 39 สถานี และสถานีเสริมในกลุ่ม A1 45 สถานี ตามแผนการขยายโครงข่ายในปีที่ 1-3 รวมทั้งอาศัยข้อมูลภูมิประเทศในการคำนวณด้วย ซึ่งภายหลังการติดตั้งครบถ้วน คาดการณ์ว่าจะมีพื้นที่ครอบคลุมทั้งคิดสิ้นคิดเป็นร้อยละ 90 ของจำนวนครัวเรือนทั้งประเทศ',
                    'ทั้งนี้ การจัดหาอุปกรณ์หรือติดตั้งโครงข่ายในสภาพพื้นที่จริงอาจมีความแตกต่างจากแบบจำลองบ้าง โดยการวิเคราะห์นี้ได้คำนวณจากพื้นที่ครอบคลุมสัญญาณในลักษณะ Fixed Rooftop ดังนั้นการรับสัญญาณในลักษณะ Portable Indoor จะมีความแตกต่างบ้างขึ้นกับปัจจัยของสิ่งแวดล้อมอาทิตึกสูงอาคารบ้านหรือสิ่งกีดขวางต่างๆ',
                    'การขยายโครงข่ายระยะที่ 4 (ปีที่ 4) มีเป้าหมายครอบคลุมจำนวนครัวเรือนไม่น้อยกว่า ร้อยละ 95 โดยอาศัยการติดตั้งสถานีเสริมเป็นการเพิ่มเติม และสำนักงาน กสทช. จะปรับปรุงข้อมูลบนแอปพลิเคชั่นนี้ต่อไป',
                    'กำหนดการขยายโครงข่ายอาจมีการปรับเปลี่ยนตามความเหมาะสม หรือตามสถานการณ์/อุปสรรคการดำเนินการ',
                ],
            },
            {
                line: [
                    'กฎหมายที่ใช้บังคับ',
                    'การใช้แอปพลิเคชั่นนี้หรือการตีความข้อตกลงและเงื่อนไขการใช้บริการเว็บไซต์นี้ให้เป็นไปตามกฎหมายไทย',
                ],
            },
        ],
    },
}

export const internalMapUrl = [
    `${process.env.REACT_APP_MAP_ARCGIS_SERVER_URL}`,
    `${process.env.REACT_APP_MAP_BASEMAP_STREET_URL}`,
]

export const permissionMenu = [
    {
        permissionId: 'DTV-001', // จัดการข้อมูลผู้ใช้งาน (UM)
        menuAllowed: [7.1, 7.2],
    },
    {
        permissionId: 'DTV-002', // จัดการเนื้อหา (CMS)
        menuAllowed: [7.3, 7.4],
    },
    {
        permissionId: 'DTV-003', // นำเข้าข้อมูลภาคสนาม (mobile only)
        menuAllowed: [],
    },
    {
        permissionId: 'DTV-004', // รายงานข้อเสนอแนะ
        menuAllowed: [5],
    },
    {
        permissionId: 'DTV-005', // รายงานการนำเข้าข้อมูล
        menuAllowed: [6],
    },
    {
        permissionId: 'DTV-006', // จัดการ MUX
        menuAllowed: [7.5],
    },
]

export let menuMap = [
    {
        id: 99,
        name: 'Firstname Lastname',
        path: '/login', // --> '/profile'
        display: true,
    },
    {
        id: 2,
        name: 'ข้อมูลช่องรายการ',
        path: '/channel',
        display: true,
    },
    {
        id: 3,
        name: 'วิธีการติดตั้ง และรับชม',
        path: '/guide',
        display: true,
    },
    {
        id: 4,
        name: 'แผนการขยายโครงข่ายฯ',
        path: '/plan',
        display: true,
    },
    {
        id: 5,
        name: 'รายงานข้อเสนอแนะ',
        path: '/report-feedback',
        display: false,
    },
    {
        id: 6,
        name: 'รายงานผลการนำเข้า',
        path: '/report-survey',
        display: false,
    },
    {
        id: 7,
        name: 'ระบบการจัดการ',
        path: '/backoffice/usergroup-management',
        display: false,
    },
    {
        id: 1,
        name: 'เพิ่มแผนที่จากหน่วยงานอื่น',
        path: '/map-layer',
        display: true,
    },
    {
        id: 8,
        name: 'ช่วยเหลือ',
        path: '/help',
        display: true,
    },
    {
        id: 9,
        name: 'ติดต่อเรา',
        path: '/contact',
        display: true,
    },
]

export let menuBackoffice = [
    {
        id: 7.1,
        name: 'จัดการกลุ่มผู้ใช้งาน',
        path: '/backoffice/usergroup-management',
        active: false,
        display: false,
    },
    {
        id: 7.2,
        name: 'จัดการผู้ใช้งาน',
        path: '/backoffice/user-management',
        active: false,
        display: false,
    },
    {
        id: 7.3,
        name: 'จัดการเนื้อหา',
        path: '/backoffice/content-management',
        active: false,
        display: false,
    },
    {
        id: 7.4,
        name: 'จัดการข้อมูลติดต่อเรา',
        path: '/backoffice/contact-management',
        active: false,
        display: false,
    },
    {
        id: 7.5,
        name: 'จัดการ MUX',
        path: '/backoffice/mux-management',
        active: false,
        display: false,
    },
]

export let probabilityRatio = {
    good: 0.95,
    average: 0.9,
    bad: 0.7,
}

export let cookiesNotice = {
    content: `สำนักงาน กสทช. มีการใช้งานคุกกี้เพื่อให้ผู้เข้าชมเว็บไซต์ได้รับความสะดวกสบาย 
    ได้รับการนำเสนอเนื้อหาที่เหมาะสม รวมถึงเพื่อการสนับสนุนความปลอดภัย 
    การวิเคราะห์การทำงานของเว็บไซต์เพื่อพัฒนาบริการของสำนักงาน กสทช. ให้ดียิ่งขึ้น 
    ผู้เข้าชมเว็บไซต์สามารถเลือกกดปุ่ม "ยอมรับ" เพื่ออนุญาตให้ใช้คุกกี้ทุกประเภท ทั้งนี้ สำนักงาน กสทช. 
    ขอเรียนให้ผู้เข้าชมเว็บไซต์ทราบว่าหากท่านไม่ยอมรับการใช้งานคุกกี้ 
    การนำเสนอเนื้อหาและการใช้งานเว็บไซต์จะไม่ได้รับความสะดวกสบายในการใช้บริการ 
    โดยผู้เข้าชมเว็บไซต์สามารถศึกษารายละเอียดเพิ่มเติมได้ที่`,
    policyLink: 'https://nbtc.go.th/Special-Page/privacypolicy.aspx?lang=th-TH&lang=th-th',
    txtHyperlink: 'ประกาศเกี่ยวกับคุกกี้',
    acceptButton: 'ยอมรับ',
    declineButton: 'ปฏิเสธ',
}

export let privacyPolicy = {
    title: 'นโยบายความเป็นส่วนตัว',
    content1:
        'สำนักงานคณะกรรมการกิจการกระจายเสียง กิจการโทรทัศน์ และกิจการโทรคมนาคมแห่งชาติ (สำนักงาน กสทช.) ขอแจ้งว่าสำนักงาน กสทช. มีการเก็บรวบรวมข้อมูลส่วนบุคคลจากผู้ใช้บริการที่มารับบริการ เพื่อให้บรรลุวัตถุประสงค์ตามอำนาจหน้าที่ของ กสทช. และสำนักงาน กสทช. อย่างมีประสิทธิภาพ อันเป็นประโยชน์โดยชอบด้วยกฎหมายของผู้ควบคุมข้อมูลส่วนบุคคลตามที่บัญญัติไว้ในพระราชบัญญัติคุ้มครองข้อมูลส่วนบุคคล พ.ศ. 2562 มาตรา 24',
    content2:
        'สำนักงาน กสทช. จะจัดให้มีมาตรการการรักษาความมั่นคงปลอดภัยของข้อมูลส่วนบุคคลที่เหมาะสม สำหรับระยะเวลาในการจัดเก็บจะดำเนินการสอดคล้องตามนโยบายการเก็บรักษาและการทำลายข้อมูลส่วนบุคคลของสำนักงาน กสทช. และอาจมีความจำเป็นต้องเปิดเผยข้อมูลส่วนบุคคลของท่านให้กับหน่วยงานที่เกี่ยวข้องเพื่อให้บรรลุวัตถุประสงค์ตามที่ระบุไว้',
    content3:
        'ท่านสามารถศึกษารายละเอียดเพิ่มเติมเกี่ยวกับนโยบายและประกาศด้านการคุ้มครองข้อมูลส่วนบุคคล ของสำนักงาน กสทช. ได้ที่',
    policyLink: 'https://nbtc.go.th/Special-Page/privacypolicy.aspx?lang=th-TH&lang=th-th',
    txtHyperlink: 'ประกาศนโยบายความเป็นส่วนตัว',
    acceptCheckbox: 'ยอมรับนโยบายความเป็นส่วนตัว',
    acceptButton: 'ตกลง',
}
